/* Copyright (C) NewFoundry 2022 All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */
"use strict";

var _classCallCheck = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.style = exports.name = exports.mapStateToProps = exports.VehicleThumbnail = void 0;

var react_1 = __importDefault(require("react"));

var utils_1 = require("./utils");

var name = 'VehicleThumbnail';
exports.name = name;

var VehicleThumbnail = function VehicleThumbnail(_ref) {
  var Frame = _ref.Frame,
      Text = _ref.Text,
      Image = _ref.Image,
      Button = _ref.Button,
      styles = _ref.styles,
      AnalyticsApi = _ref.AnalyticsApi;
  return /*#__PURE__*/function (_react_1$default$Pure) {
    _inherits(_class, _react_1$default$Pure);

    var _super = _createSuper(_class);

    function _class(props) {
      _classCallCheck(this, _class);

      return _super.call(this, props);
    }

    _createClass(_class, [{
      key: "goToModel",
      value: function goToModel(model, onSelect) {
        AnalyticsApi.track({
          action: 'Selected Model',
          category: 'Configurator',
          label: model.slug || model.id
        });

        if (onSelect) {
          onSelect(model);
        }
      }
    }, {
      key: "renderDescription",
      value: function renderDescription() {
        var description = this.props.description;

        if (description) {
          return description;
        }

        return this.renderDefaultDescription();
      }
    }, {
      key: "renderDefaultDescription",
      value: function renderDefaultDescription() {
        var _this$props = this.props,
            classes = _this$props.classes,
            model = _this$props.model;
        return react_1.default.createElement(Text, {
          className: ['VehicleThumbnail__description', classes === null || classes === void 0 ? void 0 : classes.description],
          style: styles === null || styles === void 0 ? void 0 : styles.description
        }, model.description);
      }
    }, {
      key: "renderInnerButton",
      value: function renderInnerButton() {
        var innerButton = this.props.innerButton;

        if (innerButton) {
          return innerButton;
        }

        return 'Build';
      }
    }, {
      key: "render",
      value: function render() {
        var _this = this;

        var _a, _b;

        var _this$props2 = this.props,
            classes = _this$props2.classes,
            env = _this$props2.env,
            model = _this$props2.model,
            onSelect = _this$props2.onSelect;
        var vehicleClass = "vehicle-".concat(model.id);
        return react_1.default.createElement(Frame, {
          className: ['VehicleThumbnail__container', vehicleClass, classes === null || classes === void 0 ? void 0 : classes.container],
          style: styles === null || styles === void 0 ? void 0 : styles.container
        }, react_1.default.createElement(Text, {
          className: ['VehicleThumbnail__title', classes === null || classes === void 0 ? void 0 : classes.title],
          style: styles === null || styles === void 0 ? void 0 : styles.title
        }, model.name), ((_a = model.display) === null || _a === void 0 ? void 0 : _a.thumbnail) && react_1.default.createElement(Image, {
          className: ['VehicleThumbnail__thumbnail', classes === null || classes === void 0 ? void 0 : classes.thumbnail],
          style: styles === null || styles === void 0 ? void 0 : styles.thumbnail,
          onClick: function onClick() {
            return _this.goToModel(model, onSelect);
          },
          src: utils_1.ImageUtils.getThumbnailUrl(env, model, (_b = model.display) === null || _b === void 0 ? void 0 : _b.thumbnail)
        }), this.renderDescription(), react_1.default.createElement(Button, {
          className: ['VehicleThumbnail__build', classes === null || classes === void 0 ? void 0 : classes.build],
          onClick: function onClick() {
            return _this.goToModel(model, onSelect);
          },
          style: styles === null || styles === void 0 ? void 0 : styles.build
        }, this.renderInnerButton()));
      }
    }]);

    return _class;
  }(react_1.default.PureComponent);
};

exports.VehicleThumbnail = VehicleThumbnail;

var style = function style(theme) {
  var _a, _b, _c, _d, _e, _f;

  return {
    build: Object.assign(Object.assign({
      cursor: 'pointer',
      fontSize: 16,
      height: 48,
      lineHeight: '47px',
      padding: 0,
      width: 160
    }, (_a = theme === null || theme === void 0 ? void 0 : theme.defaults) === null || _a === void 0 ? void 0 : _a.Button), (_b = theme === null || theme === void 0 ? void 0 : theme.VehicleThumbnail) === null || _b === void 0 ? void 0 : _b.build),
    container: Object.assign(Object.assign(Object.assign({
      alignItems: 'center',
      display: 'flex',
      flexDirection: 'column',
      marginBottom: 60
    }, utils_1.StyleUtils.padding('0 15px')), {
      textAlign: 'center',
      width: '100%'
    }), (_c = theme === null || theme === void 0 ? void 0 : theme.VehicleThumbnail) === null || _c === void 0 ? void 0 : _c.container),
    description: Object.assign({
      fontWeight: '300',
      fontSize: 16,
      lineHeight: '24px',
      minHeight: 86
    }, (_d = theme === null || theme === void 0 ? void 0 : theme.VehicleThumbnail) === null || _d === void 0 ? void 0 : _d.description),
    thumbnail: Object.assign({
      cursor: 'pointer',
      height: 'auto',
      marginLeft: -10,
      width: '100%'
    }, (_e = theme === null || theme === void 0 ? void 0 : theme.VehicleThumbnail) === null || _e === void 0 ? void 0 : _e.thumbnail),
    title: Object.assign({
      color: theme.primary,
      fontSize: 28,
      fontWeight: '300',
      lineHeight: '30px',
      marginBottom: 20,
      textTransform: 'capitalize'
    }, (_f = theme === null || theme === void 0 ? void 0 : theme.VehicleThumbnail) === null || _f === void 0 ? void 0 : _f.title)
  };
};

exports.style = style;

var mapStateToProps = function mapStateToProps(state, ownProps) {
  var app = state.app;
  var env = app.env;
  return {
    env: env
  };
};

exports.mapStateToProps = mapStateToProps;